import { createSelector } from 'reselect';
const getReducer = (state) => state.appConfig;
export const selectAppTheme = createSelector(getReducer, ({ theme }) => theme);
